<template>
    <v-card width="100%">
        <v-card-text>
            <v-data-table v-show="items.length > 0"
                          :headers="headers"
                          :items="items">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{ resultText }}</v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:item.action="{item}">
                    <v-icon @click="downloadFile(item.id)">mdi-arrow-down-bold-box-outline</v-icon>
                </template>
                <template v-slot:item.title="{item}">
                    <v-tooltip color="black" left open-on-focus>
                        <template v-slot:activator="{on}">
                            <span v-on="on">{{ item.title.substr(0, 45) }}...</span>
                        </template>
                        <span>{{ item.title }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card-text>
        <download-choice ref="downloadChoice"/>
    </v-card>
</template>

<script>
import downloadChoice from "@/components/downloadChoice";

export default {
    name: "rutracker",
    components: {downloadChoice},
    data() {
        return {
            headers: [
                {text: 'Название', value: 'title'},
                {text: 'Размер', value: 'size', align: 'center'},
                {text: 'Источников', value: 'seeds', align: 'center'},
                {text: 'Скачать', value: 'action', align: 'center'}
            ],
        }
    },
    methods: {
        downloadFile(id) {
            this.$refs.downloadChoice.open(id, 'ruTracker')
        }
    },
    computed: {
        items() {
            return this.$store.getters.resultSearch
        },
        resultText() {
            return this.$store.getters.resultText
        }
    }
}
</script>

<style scoped>

</style>
